/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

(function() {
  // Add custom code below this line

  (function () {
    const DESKTOP_BREAKPOINT = 750;
    const UNIFORM_RATIO = 0.8; // width / height

    function setUniformHeight(gallery) {
      if (!gallery) return;

      if (window.innerWidth < DESKTOP_BREAKPOINT) {
        gallery.style.removeProperty('--height');
        return;
      }

      const wrapper = gallery.closest('.product__wrapper--uniform');
      if (!wrapper) return;

      const slides = gallery.querySelector('.product__slides');
      if (!slides) return;

      const width = slides.clientWidth || gallery.clientWidth;
      if (!width) return;

      const height = Math.round(width / UNIFORM_RATIO);
      gallery.style.setProperty('--height', height + 'px');
    }

    function bindUniformGallery(gallery) {
      if (!gallery || gallery.dataset.uniformBound === 'true') return;
      gallery.dataset.uniformBound = 'true';

      const run = () => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            setUniformHeight(gallery);
          });
        });
      };

      run();

      gallery.addEventListener('theme:media:select', run);
      window.addEventListener('resize', run);

      const thumbs = gallery.closest('[data-product]')?.querySelectorAll('[data-thumb-link]');
      thumbs?.forEach((thumb) => {
        thumb.addEventListener('click', run);
      });

      gallery.querySelectorAll('img').forEach((img) => {
        if (!img.complete) {
          img.addEventListener('load', run, { once: true });
        }
      });
    }

    function initUniformGalleries(root = document) {
      root.querySelectorAll('.product__wrapper--uniform product-images').forEach(bindUniformGallery);
    }

    document.addEventListener('DOMContentLoaded', () => initUniformGalleries());
    document.addEventListener('shopify:section:load', (e) => initUniformGalleries(e.target));
  })();

  (function () {
    function initCollectionStickyFix() {
      if (!document.body.classList.contains('template-collection')) return;

      const header = document.querySelector('header-component[data-header-sticky]');
      if (!header) return;

      function forceSticky() {
        header.headerOffset = 0;
        header.classList.add('js__header__stuck');
        header.isStuck = true;
        document.body.classList.add('has-header-sticky');

        const measuredHeader = document.querySelector('[data-header-height]');
        if (measuredHeader) {
          document.documentElement.style.setProperty('--header-height', measuredHeader.offsetHeight + 'px');
          document.documentElement.style.setProperty('--header-sticky-height', measuredHeader.offsetHeight + 'px');
        }
      }

      function run() {
        requestAnimationFrame(() => {
          forceSticky();

          requestAnimationFrame(() => {
            forceSticky();
          });
        });
      }

      run();
      setTimeout(run, 50);
      setTimeout(run, 150);
      setTimeout(run, 300);
      setTimeout(run, 600);

      window.addEventListener('resize', run);
      document.addEventListener('theme:resize', run);
      document.addEventListener('shopify:section:load', run);
    }

    document.addEventListener('DOMContentLoaded', initCollectionStickyFix);
    window.addEventListener('load', initCollectionStickyFix);
  })();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();